import {
  InformationBox,
  MuiGrid,
  MuiButtonPrimary,
} from "../../../../components";
import PermissionWrapper from "../../../../components/permissionWrapper/PermissionWrapper";
import { MODULE_PERMISSIONS } from "../../../../helpers/constants";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { GenericAccountHeaderWrapper } from "./ViewGenericAccountHeader.style";

interface ViewGenericAccountHeaderProps {
  showEditButton?: boolean;
  title: string; // Allow customization of the title
  onEditClick?: () => void; // Callback for the Edit button
}

const ViewGenericAccountHeader = ({
  showEditButton = false,
  title,
  onEditClick,
}: ViewGenericAccountHeaderProps) => {
  const { commonLabels } = useSiteCore();
  return (
    <GenericAccountHeaderWrapper>
      <MuiGrid container className="header-container">
        <MuiGrid size={{ sm: 6, xs: 12 }} className="header-left">
          <InformationBox title={title} />
        </MuiGrid>
        <PermissionWrapper permission={MODULE_PERMISSIONS.GENERIC_ACCOUNT_EDIT}>
          {showEditButton && (
            <MuiButtonPrimary
              className="bottom-button-edit"
              onClick={onEditClick}
            >
              {commonLabels.edit}
            </MuiButtonPrimary>
          )}
        </PermissionWrapper>
      </MuiGrid>
    </GenericAccountHeaderWrapper>
  );
};

export default ViewGenericAccountHeader;
